import React, { Component } from 'react'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'
import Redactor from '~/Common-Objects/RedactorSwitch'
import clone from 'lodash/clone'
export default class Input extends Component {
    constructor(props) {
        super(props)
        this.updateHtmlValue = this.updateHtmlValue.bind(this)
    }

    updateHtmlValue(value) {
        var newObject = clone(this.props.elementData)
        newObject.content.value = value
        this.props.updateElement(newObject, this.props.path)
    }

    render() {
        let redactorEle = null
        var eleProps
        if (this.props.elementData.props) {
            eleProps = DragDropFunctions.generatePropsForStage(
                this.props.elementData.props,
                this.props.globalVariables,
                'label',
                this.props.localVariables
            )
        }
        var thisContent = this.props.elementData.content.value
        if (thisContent.indexOf('_localVariables_') >= 0)
            thisContent = DragDropFunctions.lookupLocalVariables(this.props.localVariables, thisContent)

        const isSelected = this.props.selectedElement.path === this.props.currentParentPath
        if (isSelected) {
            const elementUuid = this.props?.tuuid?.tuuid || ''
            const favoriteColors = this.props.elementsData.globalVariables.favoriteColors || []
            const color = eleProps.style.color || null
            redactorEle = (
                <Redactor
                    isLandingPage={this.props.isLandingPage}
                    campaign={this.props.campaign}
                    content={thisContent}
                    updateContent={this.updateHtmlValue}
                    defaultFont={eleProps.style.fontFamily || null}
                    defaultColor={color || null}
                    globalColours={[]}
                    favoriteColors={favoriteColors}
                    elementsData={this.props.elementsData}
                    elementUuid={elementUuid}
                    overrideTools={['bold', 'italic', 'underline']}
                    allowParagraphs={false}
                    noOuterDiv={true}
                    overridePlugins={[]}
                />
            )
        }

        return (
            <button {...eleProps}>
                {isSelected && redactorEle}
                {!isSelected && this.props.elementData.content.value && (
                    <div dangerouslySetInnerHTML={{ __html: thisContent }}></div>
                )}
                {!isSelected && !this.props.elementData.content.value && <div>{this.props.children}</div>}
            </button>
        )
    }
}
